<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'ProductsItem',

    extends: View,

    mixins: [
      LoadSections([
        // 'hero-alt',
        // 'project',
        'product-intro',
        'keep-in-touch2',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'work',
      },
    },
  }
</script>
